/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { Grid, Box, Typography, Avatar } from '@mui/material';
import './LeaveARModal.css';
import CustomModal from '../../CustomModal/CustomModal';
import ModalHeader from '../../CustomModal/ModalHeader';
import CustomTextField from '../../../components/CustomTextField/CustomTextField';
import moment from 'moment';
import CompDirection from '../../../themes/CompDirection';
import LinearProgress from '@mui/material/LinearProgress';
import { themes } from '../../../themes/themes';
import TakeActionSplitBtn from '../../../components/TakeActionSplitBtn/TakeActionSplitBtn';
import LeaveHistoryArTile from '../../../components/LeaveHistoryTileAr/LeaveHistoryTileAr';
import LeaveInsightArTile from '../../../components/LeaveInsightArTile/LeaveInsightArTile';
interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  trans?: any;
  leave_data?: any;
  leaveActions: any;
  leaveHistory: any;
  leaveInsight: any;
  userId: any;
  handleSubmitAR_Request: any;
  canAct: any;
}

const LeaveARModalPresenter = ({
  isModalOpen,
  closeModal,
  leaveActions,
  trans,
  leave_data,
  leaveHistory,
  leaveInsight,
  userId,
  handleSubmitAR_Request,
  canAct,
}: ModalProps) => {
  const [days, setDays] = useState<any>();

  useEffect(() => {
    const daysS: any =
      leave_data?.total_leave_days;
    setDays(daysS);
  }, []);

  const handleTakeAction = (x: any, event: string) => {
    if (x) {
      const payload = {
        event: event,
        instanceId: leave_data?.id,
        action: x ? x : '',
        model: 'leaves',
        userId: userId,
        context: {
          employee_type: leave_data.employee_type,
          employee_category: leave_data.employee_category,
        },
      };
      handleSubmitAR_Request(payload);
    } else {
      return;
    }
  };

  const status = ['Pending', 'Approved', 'Rejected'];
  console.log(leaveInsight, '----LE IN');
  return (
    <CustomModal isModalOpen={isModalOpen} modalHeight="98vh" modalWidth="55vw">
      <ModalHeader
        modal={{ modal_title: trans('Leave Action Required') }}
        closeModal={closeModal}
      />
      <CompDirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: '5px',
          }}
        >
          <Grid item xs={4}>
            <Box className="bg_border_ar">
              <Box
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Avatar />
                <Box style={{ paddingLeft: '10px' }}>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      color: themes.darkBlue,
                      fontSize: '1em',
                      fontWeight: 'bold',
                    }}
                  >
                    {leave_data?.first_name + ' ' + leave_data?.last_name}
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      color: themes.grey_colorDesignationAR,
                      fontSize: '0.825em',
                    }}
                  >
                    {leave_data?.designation_name}
                  </Typography>
                </Box>
              </Box>
              {/* {Info block with background color} */}
              <Box
                style={{
                  display: 'flex',
                  padding: '1em',
                  marginTop: '2em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '100px',
                  flexDirection: 'column',
                }}
              >
                <Box>
                  <Typography
                    style={{
                      color: themes.primaryMain,
                      fontSize: '0.8em',
                      fontWeight: 'bold',
                      fontFamily: 'Lato',
                    }}
                  >
                    {days > 0 ? `${days} day` : `${days} days`}
                  </Typography>
                </Box>
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <i
                    className="las la-calendar-check"
                    color={themes.defaultScondary_blue}
                  />
                  <Typography
                    style={{
                      color: themes.defaultScondary_blue,
                      fontSize: '0.8em',
                      fontWeight: 'bold',
                      fontFamily: 'Lato',
                    }}
                  >
                    : {moment(leave_data?.start_date).format('DD MMM, YYYY')}{' '}
                    <span style={{ color: '#8F95B2' }}> to </span>{' '}
                    {moment(leave_data?.end_date).format('DD MMM, YYYY')}
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    style={{
                      color: themes.greySubtitle,
                      fontSize: '0.8em',
                      fontFamily: 'Lato',
                    }}
                  >
                    Applied on:{' '}
                    {moment(leave_data?.appliedOn).format('DD MMM, YYYY')}{' '}
                  </Typography>
                </Box>
                <Box style={{ marginTop: '10px' }}>
                  <LinearProgress
                    variant="determinate"
                    value={50}
                    sx={{
                      bgcolor: '#00000029',
                      height: 4,

                      borderRadius: '10px',
                      '& .MuiLinearProgress-bar': {
                        backgroundColor: '#21D8A5', // Specify your custom bar color here
                        borderRadius: '10px',
                      },
                    }}
                  />
                </Box>
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '14px',
                      fontWeight: 'bold',
                      color: themes.defaultScondary_blue,
                    }}
                  >
                    Remaining Leaves
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '14px',
                      fontWeight: 'bold',
                      color: themes.defaultScondary_blue,
                    }}
                  >
                    {Number(leave_data?.remaining_leaves).toPrecision(2)}
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  padding: '1em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '30px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Reason
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: themes.defaultScondary_blue,
                    }}
                  >
                    {leave_data?.leave_reason}
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  padding: '1em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '30px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Attachment
                  </Typography>
                  <Box>
                    <i className="las la-eye" color={themes.primary} />
                  </Box>
                </Box>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  marginTop: '0.5em',
                  width: 'auto',
                  height: '30px',
                  flexDirection: 'column',
                }}
              >
                <Typography
                  style={{
                    fontFamily: 'Lato',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    color: themes.defaultScondary_blue,
                  }}
                >
                  Remarks
                </Typography>
                <Typography
                  style={{
                    fontFamily: 'Lato',
                    fontSize: '12px',
                    color: themes.greyModalTitle,
                  }}
                >
                  {leave_data?.remark}
                </Typography>
              </Box>
              <Box style={{ marginTop: '1.5em' }}>
                <CustomTextField
                  type="string"
                  label="Comment"
                  placeholder="Write Comment"
                />
              </Box>
              {canAct && (
                <Box
                  style={{ marginTop: '1.5em', zIndex: '999', width: '100%' }}
                >
                  <TakeActionSplitBtn
                    menu={leaveActions}
                    title={'Take Action'}
                    onAction={(x: any) => handleTakeAction(x, 'leave')}
                  />
                </Box>
              )}
            </Box>
          </Grid>
          {/* {Second Column} */}
          <Grid item xs={4}>
            <Box className="bg_border_ar">
              <Box
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Typography
                  style={{
                    fontFamily: 'Lato',
                    color: themes.primaryMain,
                    fontSize: '0.875em',
                    fontWeight: 'bold',
                  }}
                >
                  Leave History
                </Typography>
              </Box>
              {leaveHistory?.length > 0 &&
                leaveHistory.map((leave: any) => {
                  return (
                    <div key={leave.id}>
                      <LeaveHistoryArTile
                        actorName=""
                        date1={moment(leave?.start_date).format('DD MMM, YYYY')}
                        date2={moment(leave?.end_date).format('DD MMM, YYYY')}
                        dayOrAmount={leave?.total_leave_days}
                        remarks={leave?.remark}
                        status={status[leave?.status]}
                        typeName={leave?.leave_type?.name}
                      />
                    </div>
                  );
                })}
            </Box>
          </Grid>
          {/* {Third Column} */}
          <Grid item xs={4}>
            <Box className="bg_border_ar">
              <Box
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Typography
                  style={{
                    fontFamily: 'Lato',
                    color: themes.primaryMain,
                    fontSize: '0.875em',
                    fontWeight: 'bold',
                  }}
                >
                  Insight
                </Typography>
              </Box>
              {leaveInsight?.length > 0 &&
                leaveInsight.map((ins: any) => {
                  return (
                    <div key={ins?.id}>
                      <LeaveInsightArTile
                        designation={ins?.designation_name}
                        department={ins?.department_name}
                        emp_name={ins?.first_name + ' ' + ins?.last_name}
                        leave_day={ins?.day_freq}
                        status={ins?.status}
                        leave_type={ins?.leave_type}
                      />
                    </div>
                  );
                })}
            </Box>
          </Grid>
        </Grid>
      </CompDirection>
    </CustomModal>
  );
};

export default LeaveARModalPresenter;
